import { render, staticRenderFns } from "./Mouth3.vue?vue&type=template&id=5a6b8472&"
import script from "./Mouth3.vue?vue&type=script&lang=js&"
export * from "./Mouth3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports